import {
	Box,
	FormControlLabel,
	FormHelperText,
	Radio,
	RadioGroup,
} from "@mui/material";
import { ITest, LabelPlacement } from "@websential/cosmic-v20";
import React, { FC } from "react";

export interface IRadioOption {
	/**
	 * Radio props
	 * The id of the input radio field.
	 */
	id?: string;
	/**
	 * The label of the radio field.
	 */
	label?: string;
	/**
/**
 * The value of the radio field.
 */
	value?: any;
	/**
	 * If true, the component is checked.
	 */
	checked?: boolean;
	/**
	 * Set the position of label on the start or end of the input
	 */
	labelPlacement?: LabelPlacement;

	description?: string;
}

/**
 * The props and the CSS customization points from Material UI RadioGroup API
 */
export interface IEnhancedRadioGroup extends ITest {
	/**
	 * The label of the RadioGroup content.
	 */
	// label?: string;
	/**
	 * The name used to reference the value of the RadioGroup control.
	 * If you don't provide this prop,
	 * it falls back to a randomly generated name.
	 */
	name: string;
	/**
	 * The Value of the selected radio button.
	 */
	value?: string;
	/**
	 * If true, the radio will be disabled.
	 */
	disabled?: boolean;
	/**
	 * If true, the checkbox will be readOnly.
	 */
	readOnly?: boolean;
	/**
	 * The content of the radio component.
	 */
	options: IRadioOption[];
	/**
	 * Render the radio options as row or column.
	 */
	displayAsRow?: boolean;
	// /**
	//  * Set the position of label on the top or left of the input
	//  */
	// labelPosition?: LabelPosition;
	/**
	 * on change handler.
	 * Callback fired when a radio button is selected.
	 */
	onChangeHandler?: (
		e: React.ChangeEvent<HTMLInputElement> | null | any
	) => void | any;
	/**
	 * Error message to be displayed
	 */
	helperText?: string | any;
}

// const useStyles = styled(() =>
//   createStyles({
//     readOnly: {
//       color: " rgba(0, 0, 0, 0.26) !important",
//     },
//     fieldError: {
//       margin: "4px 14px 0 0px",
//     },
//   })
// );

/**
 * RadioGroup is a helpful wrapper used to group Radio.
 * The EnhancedRadioGroup using the component EnhancedRadioButton.
 */
export const EnhancedRadioGroup: FC<IEnhancedRadioGroup> = ({
	// label,
	name,
	value,
	disabled = false,
	readOnly = false,
	options,
	// labelPosition,
	testId,
	displayAsRow = true,
	onChangeHandler,
	helperText,
}) => {
	const renderOptionList = () => {
		return options.map((data, index) => (
			<Box key={data.value}>
				<FormControlLabel
					data-testid={"radio-" + index}
					control={
						<Radio
							color="primary"
							readOnly={readOnly}
							key={data.value}
						/>
					}
					id={data.id}
					value={data.value}
					disabled={disabled || readOnly}
					labelPlacement={data.labelPlacement}
					label={data.label}
				/>
				{data.description && (
					<Box
						sx={{
							fontSize: ".875rem",
							color: "text.secondary",
							paddingLeft: "0", // aligns under label, not radio
							marginTop: "-8px",
							marginBottom: "8px"
						}}
					>
						{data.description}
					</Box>
				)}
			</Box>
		));
	};
	// const classes = useStyles();
	return (
		<>
			<RadioGroup
				row={displayAsRow}
				data-testid={testId + "-form-group"}
				name={name}
				value={value}
				onChange={!readOnly ? onChangeHandler : undefined}
			// className={readOnly ? classes.readOnly : ""}
			>
				{renderOptionList()}
			</RadioGroup>
			<FormHelperText
				sx={{
					margin: "4px 14px 0 0px",
				}}
				// className={classes.fieldError}
				error
				role="alert"
			>
				{helperText}
			</FormHelperText>
		</>
	);
};
